// extracted by mini-css-extract-plugin
export default {"message":"CoreWrapper_message__VJiO4","messageContent":"CoreWrapper_messageContent__NK-RD","messageHeader":"CoreWrapper_messageHeader__+6Zaf"};